import { render, staticRenderFns } from "./button-transparent.vue?vue&type=template&id=58e7f7ec&"
import script from "./button-transparent.vue?vue&type=script&lang=js&"
export * from "./button-transparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports